module.exports = "export default __webpack_public_path__ + &quot;67fd90bc49b4e6d4541bef31974c570e.svg&quot;;"